import { render, staticRenderFns } from "./ReplyBottomPanel.vue?vue&type=template&id=86473174&scoped=true&"
import script from "./ReplyBottomPanel.vue?vue&type=script&lang=js&"
export * from "./ReplyBottomPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReplyBottomPanel.vue?vue&type=style&index=0&id=86473174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86473174",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86473174')) {
      api.createRecord('86473174', component.options)
    } else {
      api.reload('86473174', component.options)
    }
    module.hot.accept("./ReplyBottomPanel.vue?vue&type=template&id=86473174&scoped=true&", function () {
      api.rerender('86473174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/WootWriter/ReplyBottomPanel.vue"
export default component.exports